const allLookAndFeelAttributes = {
    number: "1/5",
    question: "Look and Feel",
    description: `Before we design your brand, we need to understand its overall
                personality and charisma. Just like people, we change how we
                dress over time, but people will still recognize us by our
                style. So, if your brand were a person, walking in the street,
                and you saw them from afar, what would they look like? Another
                analogy would be: if they were a bar, what would the interior
                look like? - Only use adjectives.`
}

const fiveLookAndFeelAttributes = {
    number: "2/5",
    question: "Look and Feel",
    description: "Pick the top 5 attributes"
}

const threeLookAndFeelAttributes = {
    number: "3/5",
    question: "Look and Feel",
    description: "Pick the top 3 attributes"
}

const companiesThatLookLikeThat1 = {
    number: "4/5",
    question: "Look and Feel",
    description: "List companies that look like that"
}

const companiesThatLookLikeThat2 = {
    number: "5/5",
    question: "Look and Feel",
    description: "List brands or celebrities that you love how they look"
}

export const questions = {
    allLookAndFeelAttributes: allLookAndFeelAttributes,
    fiveLookAndFeelAttributes: fiveLookAndFeelAttributes,
    threeLookAndFeelAttributes: threeLookAndFeelAttributes,
    companiesThatLookLikeThat1: companiesThatLookLikeThat1,
    companiesThatLookLikeThat2: companiesThatLookLikeThat2,
}

const allLookAndFeelAttributesVideo = {
    url: "https://www.dropbox.com/scl/fi/8hohbr8qgntn5lak9fqhn/20-Look-and-Feel-1.mp4?rlkey=c5t17ryq3bwj7hdgh758d7fry&raw=1"
}

const fiveLookAndFeelAttributesVideo = {
    url: "https://www.dropbox.com/scl/fi/8htsfqy4z70pz3cbeozlc/21-Look-and-Feel-Filter-5.mp4?rlkey=p5yay0fhfu5tn9w045xwypc2h&raw=1"
}

const threeLookAndFeelAttributesVideo = {
    url: "https://www.dropbox.com/scl/fi/xrnjs36uio04tocny4bnf/22-Look-and-feel-filter-3.mp4?rlkey=tl3h4mblikxdde92jj2d32aat&raw=1"
}

export const videos = {
    allLookAndFeelAttributesVideo: allLookAndFeelAttributesVideo,
    fiveLookAndFeelAttributesVideo: fiveLookAndFeelAttributesVideo,
    threeLookAndFeelAttributesVideo: threeLookAndFeelAttributesVideo
}